import done from "../images/download.png";
import wait from "../images/wait.gif";
export function NavySearchCard({ navy, status }) {

  return (
    <>
      <div className="ten wide mobile five wide computer column">
        <div id="{navy}" className="done navy-card">
          {navy}
          <img
            src={status === "searching" ? wait : done}
            alt="status"
            width="16"
            height="16"
          />
        </div>
      </div>
    </>
  );
}
